<script>
  import { fade, blur, fly, slide, draw, crossfade } from 'svelte/transition'
  import { getContext } from 'svelte'

  export let scale
  export let stroke = 'red'
  export let fill = '#000'
  export let strokeWidth = 1
  export let values
  export let data
  export let height, width
  export let padding = 1
  let { margin } = getContext('chart')

  // calculate barWidth
  $: barWidth = (width - margin.left - margin.right) / data.length - padding

  function mouseover(e) {
    console.log(e)
  }
</script>

{#each data as d, i}
  <!-- svelte-ignore a11y-mouse-events-have-key-events -->
  <rect
    in:fly={{ x: 100, duration: 1000 }}
    out:fly={{ x: 100, duration: 1000 }}
    on:mouseover={mouseover}
    x={scale.x(d.date) - barWidth / 2}
    height={height - margin.bottom - scale.y(d[values.y])}
    y={scale.y(d[values.y])}
    width={barWidth}
    {fill}
    data:date={d.date}
    data:vaccinations={d.vaccinated_daily}
  />
  <!-- .attr('width', xScale.bandwidth())
    .attr('height', function(d){return 400 - yScale(d.value)})
    .attr('y', function(d){return yScale(d.value)})
    .attr('x', function(d,i){return xScale(i)}); -->
{/each}
